// Mirror of the Calance engine's IncludesRule.preventsAdd matching logic.
// See docs/kubota-configuration-engine.js:531-571 (preventsAdd) and :925-942 (RuleTypeCode dispatch).
// Used to preview bundled "Include" items BEFORE configuration.tryAddItem runs,
// so the user can confirm or cancel the bundled add.

const RULE_TYPE_INCLUDE = 2;

export function previewIncludeRules(addingItem, ruleList, configuredItems) {
    if (!addingItem || !Array.isArray(ruleList) || !configuredItems) return [];
    const previews = [];
    const seenTargets = new Set();

    for (const rule of ruleList) {
        if (rule.RuleTypeCode !== RULE_TYPE_INCLUDE) continue;
        if (rule.InitiatingMaterial !== addingItem.Material) continue;

        let sourceItemsMatched = 0;
        for (const si of rule.SourceAttachmentList) {
            if (Object.prototype.hasOwnProperty.call(configuredItems, si.AttachId)) {
                sourceItemsMatched++;
            } else if (si.AttachId === addingItem.AttachId) {
                sourceItemsMatched++;
            }
        }
        if (sourceItemsMatched !== rule.SourceAttachmentList.length) continue;

        const target = rule.TargetAttachmentList && rule.TargetAttachmentList[0];
        if (!target) continue;
        if (Object.prototype.hasOwnProperty.call(configuredItems, target.AttachId)) continue;
        if (seenTargets.has(target.AttachId)) continue;
        seenTargets.add(target.AttachId);

        previews.push({
            targetItem: target,
            quantity: target.MinQty || 1,
            ruleId: rule.Id ?? rule.RuleId ?? null,
        });
    }
    return previews;
}
